export default "__VITE_ASSET__DKUa6cqM__"